import { render, staticRenderFns } from "./Surowiec.vue?vue&type=template&id=5351db56&"
import script from "./Surowiec.vue?vue&type=script&lang=js&"
export * from "./Surowiec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports